var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},_vm._l((_vm.option),function(item,index){return _c('el-checkbox',{key:index,attrs:{"value":item[_vm.id] || item,"label":item[_vm.title] || item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }